import {
  Button,
  DatePicker,
  Input,
  Modal,
  Pagination,
  Select,
  Typography,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "wouter";
import { getQueryParams } from "../../utilities/getQueryParams";
import CommonAdminTable from "../components/commonTable";
import {
  ProductPerformanceAPI,
  ProductPerformanceExportAPI,
} from "../../redux/actions/adminActions/analysisActions";
const { Title } = Typography;
const ProductPerformance = () => {
  const columns = [
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      align: "center",
      render: (text) => {
        return text.toUpperCase();
      },
    },
    {
      title: "Item",
      dataIndex: "item",
      key: "title",
    },
    {
      title: "Quantity",
      dataIndex: "qty",
      key: "quantity",
      align: "center",
    },
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Order Requests: ALP Shop";
  }, []);
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const initialPage = params.page || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalData, setTotalData] = useState(1);
  console.log("totalData: ", totalData);
  const [searchValue, setSearchValue] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [sortBy, setSortBy] = useState("highest");
  const currentYear = dayjs();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const getCurrentQuarter = () => {
    const month = new Date().getMonth() + 1; // 1–12
    return Math.ceil(month / 3);
  };
  const [selectedQuarter, setSelectedQuarter] = useState(
    String(getCurrentQuarter()),
  );
  const [exportModal, setExportModal] = useState(false);
  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/admin/analysis/product-performance?page=${page}`);
  };
  useEffect(() => {
    dispatch(
      ProductPerformanceAPI({
        year: selectedYear.year(),
        quarter: selectedQuarter,
        sort: sortBy,
        page: currentPage,
        perPage: 10,
      }),
    ).then((res) => {
      setTotalData(res?.payload?.data?.data?.total);
      setDataSource(res?.payload?.data?.data?.data);
    });
  }, [dispatch, currentPage, sortBy, selectedYear, selectedQuarter]);
  const exportData = () => {
    dispatch(
      ProductPerformanceExportAPI({
        year: selectedYear.year(),
        quarter: selectedQuarter,
        sort: sortBy,
      }),
    )
      .then((res) => {
        console.log("res is: ", res);
        const csvData = res?.payload?.data;

        if (!csvData) {
          console.error("No data received");
          return;
        }

        // Create Blob
        const blob = new Blob([csvData], {
          type: "text/csv;charset=utf-8;",
        });

        // Create download URL
        const url = window.URL.createObjectURL(blob);

        // Create temporary link
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `product-performance-${res?.meta?.arg?.year}-quarter-${res?.meta?.arg?.quarter}.csv`,
        );

        // Trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.log(err);
      });
    setExportModal(false);
  };
  return (
    <>
      <div className="flex justify-between items-center">
        <Title level={2} className="text-left">
          Product Performance
        </Title>
        <div className="flex gap-2 items-center">
          {/* <label className="font-semibold">Year:</label> */}
          <DatePicker
            picker="year"
            className="rounded-md"
            placeholder="Year"
            allowClear={false}
            value={selectedYear}
            onChange={(value) => setSelectedYear(value)}
          />
          <Select
            className="w-[150px] [&_.ant-select-selector]:rounded-md"
            //   style={{ borderRadius: "6px!important" }}
            allowClear
            placeholder="Quarter"
            value={selectedQuarter}
            onChange={(value) => setSelectedQuarter(value)}
            options={[
              { label: "Quarter 1", value: "1" },
              { label: "Quarter 2", value: "2" },
              { label: "Quarter 3", value: "3" },
              { label: "Quarter 4", value: "4" },
            ]}
          />
          <Select
            className="w-[150px] [&_.ant-select-selector]:rounded-md"
            placeholder="Sort By"
            value={sortBy}
            onChange={(value) => {
              setSortBy(value);
              setCurrentPage(1);
            }}
            options={[
              {
                label: "Highest Selling",
                value: "highest",
              },
              {
                label: "Lowest Selling",
                value: "lowest",
              },
            ]}
          />
          <Button
            type="primary"
            className="rounded-md"
            onClick={() => setExportModal(true)}
          >
            EXPORT
          </Button>
        </div>
      </div>

      <div className="mb-8 flex items-center justify-between max-sm:flex-col max-sm:gap-4">
        {/* <div className="sm:w-1/3">
          <Input
            placeholder="Search"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div> */}
      </div>
      <CommonAdminTable columns={columns} data={dataSource} />
      <div className="flex justify-between items-center mt-4">
        <Pagination
          current={currentPage}
          total={totalData}
          pageSize={10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
      <Modal
        open={exportModal}
        onCancel={() => setExportModal(false)}
        onOk={exportData}
      >
        <div>
          <Title level={2} className="text-left">
            Product Performance
          </Title>
          <div className="flex gap-2 items-center">
            {/* <label className="font-semibold">Year:</label> */}
            <DatePicker
              picker="year"
              className="rounded-md"
              allowClear={false}
              placeholder="Year"
              onChange={(value) => setSelectedYear(value)}
            />
            <Select
              className="w-[150px] [&_.ant-select-selector]:rounded-md"
              //   style={{ borderRadius: "6px!important" }}
              allowClear
              placeholder="Quarter(optional)"
              // value={selectedQuarter}
              onChange={(value) => setSelectedQuarter(value)}
              options={[
                { label: "Quarter 1", value: "1" },
                { label: "Quarter 2", value: "2" },
                { label: "Quarter 3", value: "3" },
                { label: "Quarter 4", value: "4" },
              ]}
            />
            <Select
              className="w-[150px] [&_.ant-select-selector]:rounded-md"
              placeholder="Sort By"
              value={sortBy}
              onChange={(value) => {
                setSortBy(value);
                setCurrentPage(1);
              }}
              options={[
                {
                  label: "Highest Selling",
                  value: "highest",
                },
                {
                  label: "Lowest Selling",
                  value: "lowest",
                },
              ]}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
export default ProductPerformance;
